export const initialState = {
  fy_year: "",
  quarter: "",
  alertName: "",
  alertDescription: "",
  user: "",
  token: "",
  moduleType: "",
  pmsName: "",
  cmmType: "",
  sebiCmmFilters: {},
  CMMType: "Compliance Reporting Category 1",
  fundOptions: [],
  uploadType: "",
  PMSTrackerData: {},
  PMSTrackerPageData: {},
  SEBITrackerData: {},
  SEBITrackerPageData: {},
  SaveData: {},
  uploadTrigger: {},
  fileDetails: {},
  fileName: "",
  totalClosed: "",
  setSubmitState: false,
  setFilter: true,
  pmsOpenNestedList: {
    "localRemarksData": [],
    "localStatusData": [],
    "localGuidanceData": [],
    "localQuarterData": ['Q1'],
  },
  CMMTrackerPageData: {},
};

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_USER":
      return { ...state, user: action.user };

    case "SET_TOKEN":
      return { ...state, token: action.token };

    case "SHOW_LOADER":
      return { ...state, pageLoading: true };

    case "HIDE_LOADER":
      return { ...state, pageLoading: false };

    case "fy_year":
      return { ...state, fy_year: action.fy_year };

    case "quarter":
      return { ...state, quarter: action.quarter };

    case "totalClosed":
      return { ...state, totalClosed: action.totalClosed };

    case "alertName":
      return { ...state, alertName: action.alertName };

    case "alertDescription":
      return { ...state, alertDescription: action.alertDescription };

    case "uploadType":
      return { ...state, uploadType: action.uploadType };

    case "PMSTrackerData":
      return { ...state, PMSTrackerData: action.PMSTrackerData };

    case "PMSTrackerPageData":
      return { ...state, PMSTrackerPageData: action.PMSTrackerPageData };

    case "SEBITrackerData":
      return { ...state, SEBITrackerData: action.SEBITrackerData };

    case "SEBITrackerPageData":
      return { ...state, SEBITrackerPageData: action.SEBITrackerPageData };

    case "pmsName":
      return { ...state, pmsName: action.pmsName };

    case "fundOptions":
      return { ...state, fundOptions: action.fundOptions };

    case "moduleType":
      return { ...state, moduleType: action.moduleType };

    case "SaveData":
      return { ...state, SaveData: action.SaveData };

    case "fileName":
      return { ...state, fileName: action.fileName };

    case "CMM_HYTR_UPLOAD":
      return { ...state, uploadTrigger: action.uploadTrigger };
    case "fileDetails":
      return { ...state, fileDetails: action.fileDetails };

    case "setFilters":
      return { ...state, setFilters: action.setFilters };

    case "setSubmitState":
      return { ...state, setSubmitState: action.setSubmitState };
    case "SET_OpenNestedList":
      return { ...state, pmsOpenNestedList: action.pmsOpenNestedList };
    case "SET_filter":
      return { ...state, setFilter: action.setFilter };
    case "CMMTrackerPageData":
      return { ...state, CMMTrackerPageData: action.CMMTrackerPageData};
    default:
      return state;
  }
};

export default reducer;
